import React, { useState, useEffect } from 'react';
import { 
  collection, addDoc, query, onSnapshot, serverTimestamp, doc, getDoc, setDoc, deleteDoc, where, getDocs, updateDoc, writeBatch, limit, orderBy, startAfter 
} from "firebase/firestore";

// AGGIUNGI: Folder, CheckSquare, Square, ArrowUp a questo import esistente
import { 
  FolderOpen, Image as ImageIcon, LogOut, FileText, User, Plus, Loader2, Users, ShieldAlert, X, Edit, Trash2, Camera, Briefcase, ChevronLeft, ChevronRight, Download, Folder, CheckSquare, Square, ArrowUp, Mail, Check, Video, PlayCircle, MessageSquare // <--- AGGIUNTO Mail e Check
} from 'lucide-react';

// FIREBASE: Importiamo le funzioni di utilitÃ  (Auth/Firestore/Storage)
import { 
  onAuthStateChanged, signOut, signInWithEmailAndPassword, createUserWithEmailAndPassword 
} from "firebase/auth";
import { 
  ref, uploadBytes, getDownloadURL, deleteObject,uploadBytesResumable 
} from "firebase/storage";

// IMPORTANTE: Importiamo le istanze inizializzate dal TUO file firebase.js
import { auth, db, storage } from './firebase';
import './App.css';
import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';
import PasswordChangeModal from './PasswordChangeModal';
import TermsModal from './TermsModal';
import ImageLightbox from './ImageLightbox';
import ThumbnailImage from './ThumbnailImage';
import ReviewsPage from './ReviewsPage';

// --- 2. COMPONENTI UI ---

const Sidebar = ({ activeTab, setActiveTab, onLogout, role }) => (
  <aside className="sidebar">
    <div className="logo">
      <img src="/ITAD-LOGO2.jpg" alt="ITAD Logo" className="logo-img" />
    </div>
    <nav className="nav-menu">
      <button className={`nav-btn ${activeTab === 'materials' ? 'active' : ''}`} onClick={() => setActiveTab('materials')}>
        <FolderOpen size={20} /> Materials
      </button>
      <button className={`nav-btn ${activeTab === 'gallery' ? 'active' : ''}`} onClick={() => setActiveTab('gallery')}>
        <ImageIcon size={20} /> Gallery
      </button>
      <button className={`nav-btn ${activeTab === 'workshop' ? 'active' : ''}`} onClick={() => setActiveTab('workshop')}>
        <Briefcase size={20} /> Assignment
      </button>
      <button className={`nav-btn ${activeTab === 'reviews' ? 'active' : ''}`} onClick={() => setActiveTab('reviews')}>
  <MessageSquare size={20} /> Reviews
</button>
      {/* TUTTI VEDONO IL PROFILO */}
      <button className={`nav-btn ${activeTab === 'profile' ? 'active' : ''}`} onClick={() => setActiveTab('profile')}>
        <User size={20} /> My Profile
      </button>
      
      {/* ADMIN E DOCENTI VEDONO GESTIONE UTENTI */}
      {(role === 'admin' || role === 'docente') && (
        <button className={`nav-btn ${activeTab === 'admin' ? 'active' : ''}`} onClick={() => setActiveTab('admin')}>
          <ShieldAlert size={20} /> User Management
        </button>
      )}

      <button className="nav-btn logout-btn" onClick={onLogout}>
        <LogOut size={20} /> Logout
      </button>
    </nav>
  </aside>
);

const LoginRegister = () => {
  const [isRegistering, setIsRegistering] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      if (isRegistering) {
        // LOGICA REGISTRAZIONE
        const q = query(collection(db, 'whitelist'), where('email', '==', email.toLowerCase()));
        const snapshot = await getDocs(q);

        if (snapshot.empty) {
          throw new Error("Email not authorized. Please ask administration to add you.");
        }

        const allowedRole = snapshot.docs[0].data().role;

        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;

        await setDoc(doc(db, 'users', user.uid), {
          email: user.email,
          role: allowedRole,
          createdAt: serverTimestamp()
        });

      } else {
        await signInWithEmailAndPassword(auth, email, password);
      }
    } catch (err) {
      console.error(err);
      setError(err.message.replace('Firebase:', '').replace('Error', ''));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="logo" style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <img src="/ITAD-LOGO2.jpg" alt="ITAD Logo" className="logo-img-login" />
        </div>
        <h3>{isRegistering ? 'Activate Account' : 'Login'}</h3>
        
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '1rem' }}>
          <input 
            className="input-text" 
            type="email" 
            placeholder="Email" 
            value={email} 
            onChange={e => setEmail(e.target.value)} 
            required 
          />
          <input 
            className="input-text" 
            type="password" 
            placeholder="Password" 
            value={password} 
            onChange={e => setPassword(e.target.value)} 
            required 
          />
          
          {error && <div style={{ color: 'red', fontSize: '0.8rem', background: '#ffebee', padding: '0.5rem', borderRadius: '4px' }}>{error}</div>}

          <button className="btn-primary" type="submit" disabled={loading} style={{justifyContent: 'center'}}>
            {loading ? <Loader2 className="animate-spin" /> : (isRegistering ? 'Create Account' : 'Enter')}
          </button>
        </form>

        
      </div>
    </div>
  );
};


// --- MODALE GESTIONE UTENTE (Aggiornato con Nome, Cognome, Telefono) ---
const UserManagementModal = ({ isOpen, onClose, editingUser, onSave }) => {
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [role, setRole] = useState('student');
  const [resetPassword, setResetPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Popola i campi se stiamo modificando
  useEffect(() => {
    if (editingUser) {
      setEmail(editingUser.email);
      setFirstName(editingUser.firstName || '');
      setLastName(editingUser.lastName || '');
      setPhone(editingUser.phone || '');
      setRole(editingUser.role);
      setResetPassword(false);
    } else {
      setEmail('');
      setFirstName('');
      setLastName('');
      setPhone('');
      setRole('student');
      setResetPassword(false);
    }
  }, [editingUser]);

  if (!isOpen) return null;

  const handleSubmit = async () => {
    if (!email || !firstName || !lastName) {
      alert('Email, First Name and Last Name are required');
      return;
    }
    
    setIsSubmitting(true);
    try {
      await onSave({ 
        email: email.toLowerCase(),
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        phone: phone.trim(),
        role,
        resetPassword: editingUser ? resetPassword : false 
      });
      onClose();
    } catch (e) {
      alert("Error: " + e.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '500px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1.5rem' }}>
          <h3>{editingUser ? 'Edit User' : 'New User'}</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
            <X color="#666" />
          </button>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          {/* EMAIL */}
          <div>
            <label style={{ fontSize: '0.85rem', color: '#666', marginBottom: '0.5rem', display: 'block' }}>
              User Email *
            </label>
            <input 
              className="input-text" 
              placeholder="e.g. mario.rossi@polimi.it" 
              value={email} 
              onChange={e => setEmail(e.target.value)}
              readOnly={!!editingUser}
              style={editingUser ? { background: '#f5f5f5', cursor: 'not-allowed' } : {}}
            />
            {editingUser && (
              <p style={{ fontSize: '0.75rem', color: '#999', marginTop: '0.25rem' }}>
                Email cannot be changed
              </p>
            )}
          </div>

          {/* NOME E COGNOME - Due colonne */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
            <div>
              <label style={{ fontSize: '0.85rem', color: '#666', marginBottom: '0.5rem', display: 'block' }}>
                First Name *
              </label>
              <input 
                className="input-text" 
                placeholder="Mario" 
                value={firstName} 
                onChange={e => setFirstName(e.target.value)}
              />
            </div>
            <div>
              <label style={{ fontSize: '0.85rem', color: '#666', marginBottom: '0.5rem', display: 'block' }}>
                Last Name *
              </label>
              <input 
                className="input-text" 
                placeholder="Rossi" 
                value={lastName} 
                onChange={e => setLastName(e.target.value)}
              />
            </div>
          </div>

          {/* TELEFONO (opzionale) */}
          <div>
            <label style={{ fontSize: '0.85rem', color: '#666', marginBottom: '0.5rem', display: 'block' }}>
              Phone (Optional)
            </label>
            <input 
              className="input-text" 
              type="tel"
              placeholder="+39 123 456 7890" 
              value={phone} 
              onChange={e => setPhone(e.target.value)}
            />
          </div>

          {/* RUOLO */}
          <div>
            <label style={{ fontSize: '0.85rem', color: '#666', marginBottom: '0.5rem', display: 'block' }}>
              Role *
            </label>
            <select 
              className="input-text" 
              value={role} 
              onChange={e => setRole(e.target.value)}
            >
              <option value="student">Student</option>
              <option value="docente">Teacher</option>
              <option value="admin">Admin</option>
            </select>
          </div>

          {/* CAMPO RESETTA PASSWORD - Solo in modifica */}
          {editingUser && (
            <div style={{ 
              background: '#fff3e0', 
              padding: '1rem', 
              borderRadius: '8px',
              border: '1px solid #ffe0b2'
            }}>
              <label style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '0.5rem',
                cursor: 'pointer',
                fontSize: '0.9rem',
                fontWeight: 500
              }}>
                <input 
                  type="checkbox"
                  checked={resetPassword}
                  onChange={e => setResetPassword(e.target.checked)}
                  style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                />
                Reset password to "123456"
              </label>
              <p style={{ 
                fontSize: '0.75rem', 
                color: '#666', 
                marginTop: '0.5rem',
                marginLeft: '1.6rem' 
              }}>
                User will be required to change it at next login
              </p>
            </div>
          )}

          {/* INFO CREAZIONE NUOVO UTENTE */}
          {!editingUser && (
            <div style={{ 
              background: '#e3f2fd', 
              padding: '1rem', 
              borderRadius: '8px',
              fontSize: '0.85rem',
              color: '#1976d2'
            }}>
              â„¹ï¸ Initial password will be <strong>123456</strong>. 
              User will be required to change it at first login.
            </div>
          )}

          <button 
            className="btn-primary" 
            style={{ width: '100%', justifyContent: 'center', marginTop: '1rem' }} 
            onClick={handleSubmit} 
            disabled={isSubmitting}
          >
            {isSubmitting ? <Loader2 className="animate-spin" /> : (editingUser ? 'Save Changes' : 'Create User')}
          </button>
        </div>
      </div>
    </div>
  );
};

const AdminPanel = () => {
  const [users, setUsers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  
  // --- NUOVI STATI PER EMAIL ---
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [isSendingEmails, setIsSendingEmails] = useState(false);

  // Carica lista utenti autorizzati
  useEffect(() => {
    const q = query(collection(db, 'whitelist'));
    const unsub = onSnapshot(q, (snap) => {
      // Ordina alfabeticamente per cognome per facilitare la selezione
      const usersList = snap.docs.map(d => {
        const data = d.data();
        return { 
          ...data, 
          id: data.uid, // <--- CORREZIONE: Usa il vero UID dell'utente
          whitelistDocId: d.id // Salviamo l'ID whitelist se servisse per cancellare/modificare
        };
      });
      // Filtra eventuali utenti che non hanno ancora un UID (es. inseriti a mano male)
      const validUsers = usersList.filter(u => u.id); 
      
      validUsers.sort((a, b) => (a.lastName || '').localeCompare(b.lastName || ''));
      setUsers(validUsers);
    });
    return () => unsub();
  }, []);

  const handleOpenCreate = () => {
    setEditingUser(null);
    setIsModalOpen(true);
  };

  const handleOpenEdit = (user) => {
    setEditingUser(user);
    setIsModalOpen(true);
  };

  // --- NUOVA FUNZIONE INVIO EMAIL ---
  const handleSendWelcomeEmails = async (userIds) => {
    if (!window.confirm(`Are you sure you want to send the Welcome Email to ${userIds.length} users?`)) {
      return;
    }

    setIsSendingEmails(true);
    try {
      const sendEmailsFn = httpsCallable(functions, 'sendWelcomeEmails');
      const result = await sendEmailsFn({ userIds });
      
      if (result.data.success) {
        alert(`Emails sent successfully!\nSuccess: ${result.data.results.success.length}\nFailed: ${result.data.results.failed.length}`);
        setIsEmailModalOpen(false);
      }
    } catch (error) {
      console.error('Email error:', error);
      alert('Error sending emails: ' + error.message);
    } finally {
      setIsSendingEmails(false);
    }
  };

  const handleSaveUser = async (userData) => {
    try {
      if (editingUser) {
        // ===== MODIFICA UTENTE =====
        const updateUser = httpsCallable(functions, 'updateUser');
        const result = await updateUser({
          email: userData.email,
          firstName: userData.firstName,
          lastName: userData.lastName,
          phone: userData.phone,
          role: userData.role,
          resetPassword: userData.resetPassword
        });
        
        if (result.data.success) {
          alert(result.data.message);
          if (result.data.passwordReset) {
            alert(`Password reset to: ${result.data.tempPassword}`);
          }
        }
      } else {
        // ===== CREAZIONE UTENTE =====
        const createUser = httpsCallable(functions, 'createUser');
        const result = await createUser({
          email: userData.email,
          firstName: userData.firstName,
          lastName: userData.lastName,
          phone: userData.phone,
          role: userData.role
        });
        
        if (result.data.success) {
          alert(
            `User created!\n` +
            `Name: ${result.data.firstName} ${result.data.lastName}\n` +
            `Email: ${result.data.email}\n` +
            `Temporary password: ${result.data.tempPassword}\n\n` +
            `User will be required to change it at first login.`
          );
        }
      }
    } catch (error) {
      console.error('Error:', error);
      throw new Error(error.message || 'Operation error');
    }
  };

  const handleDelete = async (user) => {
    if(window.confirm(
      `Are you sure you want to remove ${user.firstName} ${user.lastName} (${user.email})?\n` +
      `This action is irreversible!`
    )) {
      try {
        const deleteUser = httpsCallable(functions, 'deleteUser');
        const result = await deleteUser({ email: user.email });
        
        if (result.data.success) {
          alert(result.data.message);
        }
      } catch (error) {
        console.error('Error:', error);
        alert(`Error: ${error.message}`);
      }
    }
  };

  return (
    <div style={{ padding: '2rem' }}>
      <div className="header-section">
        <div>
          <h2><Users size={24} style={{ marginRight: 10, verticalAlign: 'middle' }}/> User Management</h2>
          <p style={{ color: '#666' }}>Add or modify access permissions</p>
        </div>
        
        <div style={{ display: 'flex', gap: '10px' }}>
          {/* NUOVO BOTTONE SEND WELCOME EMAIL */}
          <button 
            className="btn-primary header-btn-desktop" 
            onClick={() => setIsEmailModalOpen(true)}
            style={{ background: 'white', color: '#333', border: '1px solid #ddd' }}
          >
            <Mail size={20} /> Send Welcome Email
          </button>

          <button className="btn-primary header-btn-desktop" onClick={handleOpenCreate}>
            <Plus size={20} /> Add User
          </button>
        </div>
      </div>

      {/* MOBILE BUTTONS */}
      <div style={{ display: 'none' }} className="mobile-admin-buttons">
         <button 
          className="btn-primary" 
          style={{ width: '100%', justifyContent: 'center', marginBottom: '0.5rem', background: 'white', color: '#333', border: '1px solid #ddd' }}
          onClick={() => setIsEmailModalOpen(true)}
        >
          <Mail size={20} /> Send Welcome Email
        </button>
        <button 
          className="btn-primary" 
          style={{ width: '100%', justifyContent: 'center', marginBottom: '1.5rem' }}
          onClick={handleOpenCreate}
        >
          <Plus size={20} /> Add User
        </button>
      </div>

      <div className="grid">
        {users.map(u => (
          <div key={u.id} className="card material-card">
            <div className="icon-box" style={{ background: u.role === 'admin' ? '#ffebee' : u.role === 'docente' ? '#fff3e0' : '#e3f2fd' }}>
              <User size={20} color={u.role === 'admin' ? '#d32f2f' : u.role === 'docente' ? '#f57c00' : '#1976d2'} />
            </div>
            <div style={{ flex: 1, overflow: 'hidden' }}>
              <h4 style={{ fontSize: '0.95rem', textOverflow: 'ellipsis', overflow: 'hidden', fontWeight: 600 }}>
                {u.firstName} {u.lastName}
              </h4>
              <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '2px' }}>
                {u.email}
              </p>
              <p style={{ textTransform: 'capitalize', fontSize: '0.75rem', color: '#888', marginTop: '2px' }}>
                {u.role === 'admin' ? 'Admin' : u.role === 'docente' ? 'Teacher' : 'Student'} {u.phone && `• ${u.phone}`}
              </p>
            </div>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <button onClick={() => handleOpenEdit(u)} style={{ border: 'none', background: 'none', cursor: 'pointer', color: '#666' }} title="Edit">
                <Edit size={18} />
              </button>
              <button onClick={() => handleDelete(u)} style={{ border: 'none', background: 'none', cursor: 'pointer', color: '#ff4444' }} title="Remove">
                <Trash2 size={18} />
              </button>
            </div>
          </div>
        ))}
        {users.length === 0 && <p style={{ color: '#999', gridColumn: '1/-1', textAlign: 'center' }}>No users configured.</p>}
      </div>

      <UserManagementModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        editingUser={editingUser} 
        onSave={handleSaveUser} 
      />

      {/* RENDERIZZA MODALE EMAIL */}
      <EmailSelectionModal 
        isOpen={isEmailModalOpen}
        onClose={() => setIsEmailModalOpen(false)}
        users={users}
        onSend={handleSendWelcomeEmails}
        isSending={isSendingEmails}
      />
    </div>
  );
};
// --- MODALE SELEZIONE EMAIL MASSIVA ---
const EmailSelectionModal = ({ isOpen, onClose, users, onSend, isSending }) => {
  const [selectedIds, setSelectedIds] = useState([]);

  // Seleziona/Deseleziona singolo utente
  const toggleUser = (uid) => {
    if (selectedIds.includes(uid)) {
      setSelectedIds(selectedIds.filter(id => id !== uid));
    } else {
      setSelectedIds([...selectedIds, uid]);
    }
  };

  // Seleziona/Deseleziona tutti
  const toggleAll = () => {
    if (selectedIds.length === users.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(users.map(u => u.id));
    }
  };

  const handleSend = () => {
    if (selectedIds.length === 0) return;
    onSend(selectedIds);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '600px', maxHeight: '80vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
          <h3>Send Welcome Email</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer' }}><X /></button>
        </div>

        <p style={{ color: '#666', marginBottom: '1rem', fontSize: '0.9rem' }}>
          Select the users who will receive the Welcome Email with the PDF attachment.
        </p>

        {/* Header Lista con Select All */}
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          padding: '10px', 
          background: '#f5f5f5', 
          borderRadius: '8px', 
          marginBottom: '10px',
          fontWeight: 600,
          fontSize: '0.9rem'
        }}>
          <div 
            onClick={toggleAll}
            style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', gap: '10px', flex: 1 }}
          >
            {selectedIds.length === users.length && users.length > 0 ? (
              <CheckSquare size={20} color="#2196f3" />
            ) : (
              <Square size={20} color="#ccc" />
            )}
            <span>Select All ({users.length})</span>
          </div>
          <span style={{ color: '#1565c0' }}>{selectedIds.length} selected</span>
        </div>

        {/* Lista Utenti Scrollabile */}
        <div style={{ flex: 1, overflowY: 'auto', border: '1px solid #eee', borderRadius: '8px', padding: '0 10px', marginBottom: '1rem' }}>
          {users.map(u => {
            const isSelected = selectedIds.includes(u.id);
            return (
              <div 
                key={u.id}
                onClick={() => toggleUser(u.id)}
                style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '12px', 
                  padding: '12px 0', 
                  borderBottom: '1px solid #f0f0f0',
                  cursor: 'pointer'
                }}
              >
                {isSelected ? (
                  <CheckSquare size={20} color="#2196f3" fill="#e3f2fd" />
                ) : (
                  <Square size={20} color="#ddd" />
                )}
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 500 }}>{u.firstName} {u.lastName}</div>
                  <div style={{ fontSize: '0.8rem', color: '#666' }}>{u.email}</div>
                </div>
                <div style={{ fontSize: '0.75rem', padding: '2px 8px', borderRadius: '4px', background: u.role === 'student' ? '#e3f2fd' : '#fff3e0', color: '#666' }}>
                  {u.role}
                </div>
              </div>
            );
          })}
        </div>

        <div style={{ display: 'flex', gap: '1rem', marginTop: 'auto' }}>
          <button 
            className="btn-primary" 
            onClick={handleSend}
            disabled={isSending || selectedIds.length === 0}
            style={{ flex: 1, justifyContent: 'center' }}
          >
            {isSending ? <Loader2 className="animate-spin" /> : (
              <>
                <Mail size={18} /> Send to {selectedIds.length} users
              </>
            )}
          </button>
          <button 
            onClick={onClose}
            style={{
              padding: '12px 24px',
              borderRadius: '8px',
              border: '1px solid #ddd',
              background: 'white',
              cursor: 'pointer',
              fontWeight: 600
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};
// --- COMPONENTE PROFILO UTENTE ---
const ProfilePage = ({ user, userRole }) => {
  const [userData, setUserData] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [photoFile, setPhotoFile] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [isUploadingPhoto, setIsUploadingPhoto] = useState(false);

  // Carica dati utente
  useEffect(() => {
    const loadUserData = async () => {
      const userDoc = await getDoc(doc(db, 'users', user.uid));
      if (userDoc.exists()) {
        const data = userDoc.data();
        setUserData(data);
        setFirstName(data.firstName || '');
        setLastName(data.lastName || '');
        setPhone(data.phone || '');
        setPhotoPreview(data.photoURL || null);
      }
    };
    loadUserData();
  }, [user]);

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPhotoFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPhotoPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUploadPhoto = async () => {
    if (!photoFile) return;
    
    setIsUploadingPhoto(true);
    try {
      const fileRef = ref(storage, `profile-photos/${user.uid}`);
      await uploadBytes(fileRef, photoFile);
      const photoURL = await getDownloadURL(fileRef);
      
      await updateDoc(doc(db, 'users', user.uid), {
        photoURL: photoURL,
        updatedAt: serverTimestamp()
      });
      
      setPhotoFile(null);
      alert('Profile photo updated!');
    } catch (error) {
      console.error('Photo upload error:', error);
      alert('Error during upload: ' + error.message);
    } finally {
      setIsUploadingPhoto(false);
    }
  };

  const handleSaveProfile = async () => {
    if (!firstName || !lastName) {
      alert('First Name and Last Name are required');
      return;
    }

    setIsSaving(true);
    try {
      await updateDoc(doc(db, 'users', user.uid), {
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        phone: phone.trim(),
        updatedAt: serverTimestamp()
      });

      // Aggiorna anche whitelist se esiste
      const whitelistQuery = await getDocs(
        query(collection(db, 'whitelist'), where('email', '==', user.email))
      );
      
      if (!whitelistQuery.empty) {
        await updateDoc(whitelistQuery.docs[0].ref, {
          firstName: firstName.trim(),
          lastName: lastName.trim(),
          phone: phone.trim(),
          updatedAt: serverTimestamp()
        });
      }

      setUserData({ ...userData, firstName, lastName, phone });
      setIsEditing(false);
      alert('Profile updated successfully!');
    } catch (error) {
      console.error('Save error:', error);
      alert('Error during save: ' + error.message);
    } finally {
      setIsSaving(false);
    }
  };

  if (!userData) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <Loader2 className="animate-spin" style={{ margin: '0 auto' }} />
      </div>
    );
  }

  return (
    <div style={{ 
      padding: '2rem', 
      maxWidth: '800px', 
      margin: '0 auto',
      width: '100%',
      boxSizing: 'border-box'
    }} className="profile-page-container">
      <div className="header-section">
        <div>
          <h2><User size={24} style={{ marginRight: 10, verticalAlign: 'middle' }}/> My Profile</h2>
          <p style={{ color: '#666' }}>View and edit your personal information</p>
        </div>
      </div>

      {/* FOTO PROFILO */}
      <div style={{ 
        background: 'white', 
        borderRadius: '16px', 
        padding: '2rem', 
        marginBottom: '1.5rem',
        textAlign: 'center',
        width: '100%',
        boxSizing: 'border-box'
      }}>
        <div style={{ position: 'relative', display: 'inline-block' }}>
          {photoPreview ? (
            <img 
              src={photoPreview} 
              alt="Profile" 
              style={{ 
                width: '150px', 
                height: '150px', 
                borderRadius: '50%', 
                objectFit: 'cover',
                border: '4px solid #eee'
              }} 
            />
          ) : (
            <div style={{
              width: '150px',
              height: '150px',
              borderRadius: '50%',
              background: '#f5f5f5',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '4px solid #eee'
            }}>
              <User size={60} color="#ccc" />
            </div>
          )}
          
          <label 
            htmlFor="photo-upload" 
            style={{
              position: 'absolute',
              bottom: '5px',
              right: '5px',
              background: '#000',
              color: 'white',
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
            }}
          >
            <Camera size={20} />
          </label>
          <input 
            id="photo-upload"
            type="file" 
            accept="image/*"
            onChange={handlePhotoChange}
            style={{ display: 'none' }}
          />
        </div>

        {photoFile && (
          <button 
            className="btn-primary" 
            onClick={handleUploadPhoto}
            disabled={isUploadingPhoto}
            style={{ marginTop: '1rem', justifyContent: 'center' }}
          >
            {isUploadingPhoto ? <Loader2 className="animate-spin" /> : 'Save Photo'}
          </button>
        )}
      </div>

      {/* DATI PROFILO */}
      <div style={{ 
        background: 'white', 
        borderRadius: '16px', 
        padding: '2rem',
        width: '100%',
        boxSizing: 'border-box'
      }}>
        {!isEditing ? (
          <>
            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ fontSize: '0.85rem', color: '#999', display: 'block', marginBottom: '0.5rem' }}>
                Full Name
              </label>
              <p style={{ fontSize: '1.1rem', fontWeight: 600 }}>
                {userData.firstName} {userData.lastName}
              </p>
            </div>

            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ fontSize: '0.85rem', color: '#999', display: 'block', marginBottom: '0.5rem' }}>
                Email
              </label>
              <p style={{ fontSize: '1rem' }}>{userData.email}</p>
            </div>

            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ fontSize: '0.85rem', color: '#999', display: 'block', marginBottom: '0.5rem' }}>
                Phone
              </label>
              <p style={{ fontSize: '1rem' }}>{userData.phone || 'Not specified'}</p>
            </div>

            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ fontSize: '0.85rem', color: '#999', display: 'block', marginBottom: '0.5rem' }}>
                Role
              </label>
              <p style={{ 
                fontSize: '1rem', 
                textTransform: 'capitalize',
                display: 'inline-block',
                background: userRole === 'admin' ? '#ffebee' : userRole === 'docente' ? '#fff3e0' : '#e3f2fd',
                color: userRole === 'admin' ? '#d32f2f' : userRole === 'docente' ? '#f57c00' : '#1976d2',
                padding: '4px 12px',
                borderRadius: '12px',
                fontWeight: 500
              }}>
                {userData.role === 'admin' ? 'Admin' : userData.role === 'docente' ? 'Teacher' : 'Student'}
              </p>
            </div>

            <button 
              className="btn-primary" 
              onClick={() => setIsEditing(true)}
              style={{ width: '100%', justifyContent: 'center' }}
            >
              <Edit size={20} /> Edit Profile
            </button>
          </>
        ) : (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
              <div>
                <label style={{ fontSize: '0.85rem', color: '#666', marginBottom: '0.5rem', display: 'block' }}>
                  First Name *
                </label>
                <input 
                  className="input-text" 
                  value={firstName} 
                  onChange={e => setFirstName(e.target.value)}
                />
              </div>
              <div>
                <label style={{ fontSize: '0.85rem', color: '#666', marginBottom: '0.5rem', display: 'block' }}>
                  Last Name *
                </label>
                <input 
                  className="input-text" 
                  value={lastName} 
                  onChange={e => setLastName(e.target.value)}
                />
              </div>
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <label style={{ fontSize: '0.85rem', color: '#666', marginBottom: '0.5rem', display: 'block' }}>
                Phone
              </label>
              <input 
                className="input-text" 
                type="tel"
                value={phone} 
                onChange={e => setPhone(e.target.value)}
                placeholder="+39 123 456 7890"
              />
            </div>

            <div style={{ display: 'flex', gap: '1rem' }}>
              <button 
                className="btn-primary" 
                onClick={handleSaveProfile}
                disabled={isSaving}
                style={{ flex: 1, justifyContent: 'center' }}
              >
                {isSaving ? <Loader2 className="animate-spin" /> : 'Save Changes'}
              </button>
              <button 
                onClick={() => {
                  setIsEditing(false);
                  setFirstName(userData.firstName || '');
                  setLastName(userData.lastName || '');
                  setPhone(userData.phone || '');
                }}
                style={{
                  flex: 1,
                  padding: '12px 24px',
                  borderRadius: '8px',
                  border: '1px solid #ddd',
                  background: 'white',
                  cursor: 'pointer',
                  fontWeight: 600
                }}
              >
                Cancel
              </button>
            </div>
          </>
        )}
      </div>
      {/* --- NUOVA SEZIONE NOTE LEGALI --- */}
      <div style={{ 
        background: 'white', 
        borderRadius: '16px', 
        padding: '2rem',
        marginTop: '1.5rem',
        width: '100%',
        boxSizing: 'border-box'
      }}>
        <h3 style={{ fontSize: '1.1rem', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <ShieldAlert size={20} color="#666" />
          Legal & Privacy
        </h3>
        
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
          <a 
            href="/termini-condizioni.html" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ 
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              padding: '12px', background: '#f9f9f9', borderRadius: '8px',
              textDecoration: 'none', color: '#333', border: '1px solid #eee'
            }}
          >
            <span style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '0.9rem' }}>
              <FileText size={18} color="#666" /> Terms and Conditions
            </span>
            <ChevronRight size={16} color="#ccc" />
          </a>

          <a 
            href="/privacy-policy.html" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ 
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              padding: '12px', background: '#f9f9f9', borderRadius: '8px',
              textDecoration: 'none', color: '#333', border: '1px solid #eee'
            }}
          >
            <span style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '0.9rem' }}>
              <ShieldAlert size={18} color="#666" /> Privacy Policy
            </span>
            <ChevronRight size={16} color="#ccc" />
          </a>

          <a 
            href="/richiesta-dati-gdpr.html" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ 
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              padding: '12px', background: '#f9f9f9', borderRadius: '8px',
              textDecoration: 'none', color: '#333', border: '1px solid #eee'
            }}
          >
            <span style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '0.9rem' }}>
              <User size={18} color="#666" /> Request Your Data (GDPR)
            </span>
            <ChevronRight size={16} color="#ccc" />
          </a>
        </div>
      </div>
    </div>
  );
};

// --- COMPONENTE WORKSHOP PAGE ---
const WorkshopPage = ({ user, userRole, items, onDelete, canDelete }) => {
  const [selectedStudent, setSelectedStudent] = useState('all');
  const [students, setStudents] = useState([]);
  const [usersMap, setUsersMap] = useState({});

  // Carica lista studenti E mappa email -> nome completo
  useEffect(() => {
    if (!user) return;
    
    // Solo admin e docenti hanno bisogno della lista completa utenti
    if (userRole !== 'admin' && userRole !== 'docente') {
      return;
    }
    
    // Carica TUTTI gli utenti per creare la mappa email -> nome
    const qAllUsers = query(collection(db, 'users'));
    const unsubAllUsers = onSnapshot(
      qAllUsers, 
      (snap) => {
        const userMapping = {};
        const studentList = [];
        
        snap.docs.forEach(d => {
          const data = d.data();
          const fullName = `${data.firstName || ''} ${data.lastName || ''}`.trim();
          
          // Aggiungi alla mappa
          userMapping[data.email] = fullName || data.email;
          
          // Se è studente, aggiungi anche alla lista
          if (data.role === 'student') {
            studentList.push({
              id: d.id,
              email: data.email,
              firstName: data.firstName || '',
              lastName: data.lastName || '',
              fullName: fullName || data.email
            });
          }
        });
        
        setUsersMap(userMapping);
        studentList.sort((a, b) => a.fullName.localeCompare(b.fullName));
        setStudents(studentList);
      },
      (error) => {
        console.error('Error loading users:', error);
        // In caso di errore, usa solo le email
        setUsersMap({});
        setStudents([]);
      }
    );

    return () => unsubAllUsers();
  }, [userRole, user]);

  // Filtra i progetti in base allo studente selezionato
  const filteredItems = React.useMemo(() => {
    if (userRole === 'student') {
      // MODIFICA: Gli studenti vedono i propri progetti OPPURE quelli caricati da admin/docenti
      return items.filter(item => 
        item.uploadedBy === user.email || 
        item.role === 'admin' || 
        item.role === 'docente'
      );
    } else if (selectedStudent === 'all') {
      // Admin/Docenti vedono tutti i progetti
      return items;
    } else {
      // Filtra per studente specifico
      return items.filter(item => item.uploadedBy === selectedStudent);
    }
  }, [items, selectedStudent, userRole, user.email]);

  // Conta progetti per studente
  const getProjectCount = (studentEmail) => {
    return items.filter(item => item.uploadedBy === studentEmail).length;
  };

  // Ottieni il nome completo da un'email
  const getFullNameFromEmail = (email) => {
    return usersMap[email] || email;
  };

  return (
    <>
      {/* FILTRO STUDENTI - Solo per admin e docenti */}
      {(userRole === 'admin' || userRole === 'docente') && (
        <div style={{
          background: 'white',
          padding: '1.5rem',
          borderRadius: '12px',
          marginBottom: '1.5rem',
          border: '1px solid #eee'
        }}>
          <label style={{
            fontSize: '0.9rem',
            fontWeight: 600,
            marginBottom: '0.75rem',
            display: 'block',
            color: '#333'
          }}>
            Filter by Student
          </label>
          <select
            className="input-text"
            value={selectedStudent}
            onChange={(e) => setSelectedStudent(e.target.value)}
            style={{
              marginBottom: 0,
              cursor: 'pointer',
              fontSize: '0.95rem'
            }}
          >
            <option value="all">All Students ({items.length} projects)</option>
            {students.map(student => (
              <option key={student.id} value={student.email}>
                {student.fullName} ({getProjectCount(student.email)} projects)
              </option>
            ))}
          </select>
        </div>
      )}

      {/* GRID PROGETTI */}
      <div className="grid">
        {filteredItems.length === 0 && (
          <p style={{color:'#999', gridColumn: '1/-1', textAlign: 'center', padding: '2rem'}}>
            {userRole === 'student' 
              ? "You haven't uploaded any projects yet."
              : selectedStudent === 'all'
                ? "No projects uploaded yet."
                : "This student hasn't uploaded any projects yet."
            }
          </p>
        )}
        
        {filteredItems.map(item => (
          <div key={item.id} className="card" style={{ position: 'relative' }}>
            <a 
              href={item.url} 
              target="_blank" 
              rel="noreferrer" 
              className="card-link"
              aria-label={`Open ${item.description || item.fileName}`}
            >
              <span style={{ display: 'none' }}>Open {item.description || item.fileName}</span>
            </a>
            
            {/* PULSANTE ELIMINA */}
            {canDelete(item) && (
              <button 
                onClick={(e) => {
                  e.preventDefault();
                  onDelete(item);
                }}
                style={{
                  position: 'absolute',
                  top: '10px',
                  right: '10px',
                  zIndex: 20,
                  background: 'rgba(255, 68, 68, 0.9)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '50%',
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.background = 'rgba(211, 47, 47, 1)'}
                onMouseLeave={(e) => e.target.style.background = 'rgba(255, 68, 68, 0.9)'}
                title="Delete file"
              >
                <Trash2 size={16} />
              </button>
            )}
            
            <div className="material-card">
              <div className="icon-box">
                <Briefcase />
              </div>
              <div style={{ flex: 1 }}>
                <h4>{item.description}</h4>
                <p style={{ marginBottom: '4px' }}>{item.fileName}</p>
                {/* Mostra nome studente per admin/docenti */}
                {(userRole === 'admin' || userRole === 'docente') && (
                  <p style={{ 
                    fontSize: '0.75rem', 
                    color: '#888',
                    fontStyle: 'italic'
                  }}>
                    Uploaded by: {getFullNameFromEmail(item.uploadedBy)}
                  </p>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

// --- 3. APP PRINCIPALE ---
export default function App() {
  const [user, setUser] = useState(null);
  const [userRole, setUserRole] = useState(null); 
  const [activeTab, setActiveTab] = useState('materials'); 
  const [loading, setLoading] = useState(true);
  const [requirePasswordChange, setRequirePasswordChange] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  // STATI PER I DATI
  const [items, setItems] = useState([]);
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const [uploadFiles, setUploadFiles] = useState([]);
  const [uploadDesc, setUploadDesc] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0); // <--- NUOVO STATO PERCENTUALE
  const [isLoading, setIsLoading] = useState(false);

  // --- NUOVI STATI PER GESTIONE CARTELLE E SELEZIONE ---
  const [currentFolderId, setCurrentFolderId] = useState(null); // null = root
  const [folderPath, setFolderPath] = useState([{ id: null, name: 'Home' }]); // Breadcrumbs
  const [selectedItems, setSelectedItems] = useState([]); // Array di ID selezionati
  const [isMoveModalOpen, setIsMoveModalOpen] = useState(false); // Per il modale "Sposta"
  
  // STATI PER LIGHTBOX GALLERY
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const [lastDoc, setLastDoc] = useState(null); // Per tenere traccia dell'ultimo elemento
const [itemsLimit, setItemsLimit] = useState(15); // Quanti elementi caricare inizialmente

// --- NUOVI STATI PER MODIFICA DESCRIZIONE ---
const [editingId, setEditingId] = useState(null); // ID dell'elemento in modifica
const [editDescription, setEditDescription] = useState(""); // Testo temporaneo

  // AUTH & RUOLO CHECK + PASSWORD CHANGE CHECK
  useEffect(() => {
  const unsubAuth = onAuthStateChanged(auth, async (currentUser) => {
    if (currentUser) {
      const userDoc = await getDoc(doc(db, 'users', currentUser.uid));
      if (userDoc.exists()) {
        const userData = userDoc.data();
        setUserRole(userData.role);
        setRequirePasswordChange(userData.requirePasswordChange || false);

        // --- AGGIUNGI QUESTO BLOCCO ---
        // Se termsAccepted non è true, mostra il modale
        if (userData.termsAccepted !== true) {
          setShowTermsModal(true);
        } else {
          setShowTermsModal(false);
        }
        // -----------------------------
      } else {
        setUserRole('student');
        // Se l'utente non ha un documento nel DB, probabilmente è un errore,
        // ma per sicurezza potresti voler mostrare i termini anche qui se li crei al volo.
      }
      setUser(currentUser);
    } else {
      setUser(null);
      setUserRole(null);
      setRequirePasswordChange(false);
      setShowTermsModal(false); // Resetta
    }
    setLoading(false);
  });
  return () => unsubAuth();
}, []);

  // CARICAMENTO DATI - SUPPORTA WORKSHOP
  useEffect(() => {
    if (!user) return;
    
    // Skip loading for profile and admin tabs
    if (activeTab === 'profile' || activeTab === 'admin') {
      setItems([]);
      return;
    }
    
    let collectionName;
    if (activeTab === 'materials') collectionName = 'materials';
    else if (activeTab === 'gallery') collectionName = 'photos';
    else if (activeTab === 'workshop') collectionName = 'workshop';
    else return;
    
    // COSTRUZIONE QUERY CONDIZIONALE
    let q;
    
    if (activeTab === 'gallery') {
      // SE È GALLERY: Usa il limite (paginazione)
      q = query(
        collection(db, collectionName), 
        orderBy('createdAt', 'desc'), 
        limit(itemsLimit) 
      );
    } else {
      // SE NON È GALLERY (Materials/Workshop): Scarica tutto senza limiti
      q = query(
        collection(db, collectionName), 
        orderBy('createdAt', 'desc')
      );
    }

    const unsubData = onSnapshot(q, (snap) => {
      const data = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      setItems(data);
    });
    
    return () => unsubData();
  }, [user, activeTab, itemsLimit]);

  const handleLogout = () => signOut(auth);

  const handleUpload = async () => {
    if (uploadFiles.length === 0) return;
    setIsUploading(true);
    setUploadProgress(0); // Reset percentuale
    
    try {
      // Determina folder e collection
      let folder, collectionName;
      if (activeTab === 'gallery') {
        folder = 'photos';
        collectionName = 'photos';
      } else if (activeTab === 'workshop') {
        folder = 'workshop';
        collectionName = 'workshop';
      } else {
        folder = 'materials';
        collectionName = 'materials';
      }

      // CICLO SU TUTTI I FILE SELEZIONATI
      for (const file of uploadFiles) {
        // 1. Creiamo il nome del file con il timestamp
        const storagePath = `${folder}/${Date.now()}_${file.name}`;
        const fileRef = ref(storage, storagePath);
        
        // Metadata per la firma (ownerId)
        const metadata = {
          customMetadata: {
            ownerId: user.uid
          }
        };
        
        // --- MODIFICA PER PROGRESS BAR ---
        // Creiamo il task di upload ma "wrappiamolo" in una Promise per poter usare await nel ciclo
        await new Promise((resolve, reject) => {
          const uploadTask = uploadBytesResumable(fileRef, file, metadata);

          uploadTask.on('state_changed', 
            (snapshot) => {
              // CALCOLO PERCENTUALE
              const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
              setUploadProgress(progress);
            }, 
            (error) => {
              // GESTIONE ERRORE
              console.error(error);
              reject(error);
            }, 
            async () => {
              // UPLOAD COMPLETATO
              try {
                const url = await getDownloadURL(uploadTask.snapshot.ref);
                
                const mimeType = file.type;
                const type = mimeType.startsWith('video/') ? 'video' : 'image';
                const finalType = (activeTab === 'gallery') ? type : 'file';

                // Salvataggio nel Database
                await addDoc(collection(db, collectionName), {
                  url,
                  storagePath: storagePath,
                  fileName: file.name,
                  mimeType: mimeType, 
                  description: uploadDesc || file.name,
                  uploadedBy: user.email,
                  role: userRole,
                  parentId: currentFolderId,
                  type: finalType, 
                  createdAt: serverTimestamp()
                });
                
                resolve(); // Segnala che questo file è finito, passa al prossimo
              } catch (dbError) {
                reject(dbError);
              }
            }
          );
        });
      }

      // Reset finale
      setIsUploadOpen(false); 
      setUploadFiles([]);
      setUploadDesc('');
      setUploadProgress(0);

    } catch (e) {
      console.error(e);
      alert("Upload error: " + e.message);
    } finally {
      setIsUploading(false);
    }
  };

  // Funzione per salvare la nuova descrizione
const handleSaveDescription = async (itemId) => {
  try {
    // Determina la collezione (photos per la gallery, workshop per workshop, ecc.)
    const collectionName = activeTab === 'workshop' ? 'workshop' : 
                           activeTab === 'gallery' ? 'photos' : 'materials';

    const docRef = doc(db, collectionName, itemId);
    
    await updateDoc(docRef, {
      description: editDescription
    });

    setEditingId(null); // Esci dalla modalità modifica
    setEditDescription(""); 
  } catch (error) {
    console.error("Errore aggiornamento:", error);
    alert("Impossibile aggiornare la descrizione.");
  }
};

  const handleDeleteFile = async (item) => {
    // Determina collection in base al tab
    let collectionName;
    if (activeTab === 'gallery') {
      collectionName = 'photos';
    } else if (activeTab === 'workshop') {
      collectionName = 'workshop';
    } else {
      collectionName = 'materials';
    }
    
    if (!window.confirm(`Are you sure you want to delete "${item.description || item.fileName}"?`)) {
      return;
    }

    try {
      // Elimina da Firestore
      await deleteDoc(doc(db, collectionName, item.id));
      
      // Elimina da Storage
      const fileRef = ref(storage, item.url);
      await deleteObject(fileRef);
      
      alert('File deleted successfully');
    } catch (e) {
      console.error('Delete error:', e);
      alert('Error during deletion: ' + e.message);
    }
  };

  // Verifica se l'utente puÃ² eliminare un file
  const canDeleteFile = (item) => {
    // Admin puÃ² eliminare tutto
    if (userRole === 'admin') return true;
    // L'utente puÃ² eliminare solo i propri file
    if (item.uploadedBy === user.email) return true;
    return false;
  };

  // Helper per ottenere il titolo della pagina
  const getPageTitle = () => {
    switch(activeTab) {
      case 'materials': return 'Study Trip Program & Academic Material';
      case 'gallery': return 'Gallery';
      case 'workshop': return 'Workshop Projects';
      default: return 'Content';
    }
  };

  const getPageDescription = () => {
    switch(activeTab) {
      case 'materials': return 'Educational resources and documents';
      case 'gallery': return 'Photos and visual content';
      case 'workshop': return 'Student final projects and presentations';
      default: return `Logged in as: ${userRole?.toUpperCase()}`;
    }
  };

  // Se utente deve cambiare password, mostra modale
  if (user && requirePasswordChange) {
    return (
      <PasswordChangeModal 
        user={user}
        onPasswordChanged={() => {
          setRequirePasswordChange(false);
          window.location.reload();
        }}
      />
    );
  }
  // Se utente deve accettare i termini
  if (user && showTermsModal) {
    return (
      <TermsModal 
        user={user} 
        onAccepted={() => {
          setShowTermsModal(false);
          // Opzionale: ricarica per sicurezza, ma setState dovrebbe bastare
        }} 
      />
    );
  }

  // ============================================================
  // NUOVE FUNZIONI PER GESTIONE FILE/CARTELLE
  // ============================================================

  // 1. Gestione Navigazione Cartelle
  const handleEnterFolder = (folder) => {
    setCurrentFolderId(folder.id);
    setFolderPath([...folderPath, { id: folder.id, name: folder.description || 'Folder' }]);
    setSelectedItems([]); // Resetta selezione entrando in una cartella
  };

  const handleNavigateUp = (index) => {
    const newPath = folderPath.slice(0, index + 1);
    setFolderPath(newPath);
    setCurrentFolderId(newPath[newPath.length - 1].id);
    setSelectedItems([]);
  };

  // 2. Creazione Cartella
  const handleCreateFolder = async () => {
    const folderName = window.prompt("Nome della nuova cartella:");
    if (!folderName) return;

    let collectionName = activeTab === 'workshop' ? 'workshop' : 'materials';

    try {
      await addDoc(collection(db, collectionName), {
        description: folderName, // Usiamo description come nome cartella per uniformità
        type: 'folder',
        parentId: currentFolderId,
        uploadedBy: user.email,
        role: userRole,
        createdAt: serverTimestamp()
      });
    } catch (e) {
      alert("Errore creazione cartella: " + e.message);
    }
  };

  // 3. Gestione Selezione
  const toggleSelection = (itemId) => {
    if (selectedItems.includes(itemId)) {
      setSelectedItems(selectedItems.filter(id => id !== itemId));
    } else {
      setSelectedItems([...selectedItems, itemId]);
    }
  };

  // 4. Azione: Sposta in Nuova Cartella
  const handleMoveToNewFolder = async () => {
    if (selectedItems.length === 0) return;
    const folderName = window.prompt("Nome della nuova cartella di destinazione:");
    if (!folderName) return;

    let collectionName = activeTab === 'workshop' ? 'workshop' : 'materials';
    setIsLoading(true);

    try {
      // A. Crea la cartella
      const folderRef = await addDoc(collection(db, collectionName), {
        description: folderName,
        type: 'folder',
        parentId: currentFolderId,
        uploadedBy: user.email,
        role: userRole,
        createdAt: serverTimestamp()
      });

      // B. Sposta gli elementi selezionati (Batch Update)
      const batch = writeBatch(db);
      selectedItems.forEach(itemId => {
        const docRef = doc(db, collectionName, itemId);
        batch.update(docRef, { parentId: folderRef.id });
      });

      await batch.commit();
      setSelectedItems([]);
      alert("Elementi spostati nella nuova cartella!");
    } catch (e) {
      alert("Errore durante lo spostamento: " + e.message);
    } finally {
      setIsLoading(false);
    }
  };

  // 5. Azione: Sposta in Cartella Esistente
  const handleMoveToExisting = async (targetFolderId) => {
    let collectionName = activeTab === 'workshop' ? 'workshop' : 'materials';
    
    try {
      const batch = writeBatch(db);
      selectedItems.forEach(itemId => {
        const docRef = doc(db, collectionName, itemId);
        batch.update(docRef, { parentId: targetFolderId });
      });

      await batch.commit();
      setSelectedItems([]);
      setIsMoveModalOpen(false);
      alert("Spostamento completato.");
    } catch (e) {
      alert("Errore spostamento: " + e.message);
    }
  };

  // 6. Azione: Elimina Multiplo
  const handleBatchDelete = async () => {
    if (!window.confirm(`Sei sicuro di voler eliminare ${selectedItems.length} elementi?`)) return;

    let collectionName = activeTab === 'workshop' ? 'workshop' : 'materials';
    setIsLoading(true);

    try {
      // Nota: Questa eliminazione non è ricorsiva per le cartelle (cancella la cartella ma i file dentro diventano "orfani").
      // Per questa implementazione base, eliminiamo i documenti selezionati.
      const batch = writeBatch(db);
      
      // Per i file, dovremmo eliminare anche dallo Storage. 
      // Qui facciamo una eliminazione "best effort": eliminiamo i doc e proviamo a eliminare i file uno a uno.
      for (const itemId of selectedItems) {
        const item = items.find(i => i.id === itemId);
        
        // 1. Aggiungi a batch delete Firestore
        const docRef = doc(db, collectionName, itemId);
        batch.delete(docRef);

        // 2. Se è un file e ha un URL, elimina da Storage (senza bloccare il batch se fallisce)
        if (item.type !== 'folder' && item.url) {
          try {
            const fileRef = ref(storage, item.url);
            await deleteObject(fileRef);
          } catch (err) {
            console.warn("Impossibile eliminare file storage o non esistente:", err);
          }
        }
      }

      await batch.commit();
      setSelectedItems([]);
    } catch (e) {
      alert("Errore eliminazione: " + e.message);
    } finally {
      setIsLoading(false);
    }
  };

  // --- RENDERING ---
  // AGGIUNGI: || isLoading
  if (loading || isLoading) return <div style={{height:'100vh', display:'flex', alignItems:'center', justifyContent:'center'}}><Loader2 className="animate-spin" /></div>;
  
  if (!user) return <LoginRegister />;

  // PAGINA PROFILO
  if (activeTab === 'profile') {
    return (
      <div className="app-container">
        <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} onLogout={handleLogout} role={userRole} />
        
        <header className="mobile-header">
          <img src="/ITAD-LOGO2.jpg" alt="ITAD Logo" className="logo-mobile" />
          <button onClick={handleLogout} style={{background:'none', border:'none', cursor: 'pointer'}}>
            <LogOut size={20} />
          </button>
        </header>

        <main className="main-content">
          <ProfilePage user={user} userRole={userRole} />
        </main>

        <nav className="bottom-nav">
          <button 
            className={`nav-item ${activeTab === 'materials' ? 'active' : ''}`} 
            onClick={() => setActiveTab('materials')}
          >
            <FolderOpen size={20} />
            <span>Materials</span>
          </button>
          
          <button 
            className={`nav-item ${activeTab === 'gallery' ? 'active' : ''}`} 
            onClick={() => setActiveTab('gallery')}
          >
            <ImageIcon size={20} />
            <span>Gallery</span>
          </button>
          
          <button 
            className={`nav-item ${activeTab === 'workshop' ? 'active' : ''}`} 
            onClick={() => setActiveTab('workshop')}
          >
            <Briefcase size={20} />
            <span>Workshop</span>
          </button>
          <button 
  className={`nav-item ${activeTab === 'reviews' ? 'active' : ''}`} 
  onClick={() => setActiveTab('reviews')}
>
  <MessageSquare size={20} />
  <span>Reviews</span>
</button>
          <button 
            className={`nav-item ${activeTab === 'profile' ? 'active' : ''}`} 
            onClick={() => setActiveTab('profile')}
          >
            <User size={20} />
            <span>Profile</span>
          </button>

          {(userRole === 'admin' || userRole === 'docente') && (
            <button 
              className={`nav-item ${activeTab === 'admin' ? 'active' : ''}`} 
              onClick={() => setActiveTab('admin')}
            >
              <Users size={20} />
              <span>Users</span>
            </button>
          )}
        </nav>
        
        {/* MODAL UPLOAD - disponibile anche da profilo */}
        {isUploadOpen && (
          <div className="modal-overlay">
            <div className="modal-content">
              <div style={{display:'flex', justifyContent:'space-between', marginBottom:'1rem'}}>
                <h3>Upload File</h3>
                <button onClick={() => setIsUploadOpen(false)} style={{border:'none', background:'none'}}><X/></button>
              </div>
              
              <div className="upload-area">
                <input 
                  type="file" 
                  multiple 
                  accept={activeTab === 'gallery' ? "image/*,video/*" : "*/*"} 
                  onChange={e => setUploadFiles(Array.from(e.target.files))} 
                />
                
                {/* Mostra riepilogo file selezionati */}
                {uploadFiles.length > 0 ? (
                  <div style={{textAlign: 'left', maxHeight: '100px', overflowY: 'auto'}}>
                    <p style={{fontWeight: 'bold', marginBottom: '5px'}}>{uploadFiles.length} files selected:</p>
                    {uploadFiles.map((f, i) => (
                      <p key={i} style={{fontSize: '0.8rem', margin: 0}}>• {f.name}</p>
                    ))}
                  </div>
                ) : (
                  <p>Select files</p>
                )}
              </div>

              <div style={{marginBottom: '1rem'}}>
                 <label style={{fontSize: '0.85rem', color: '#666', marginBottom: '0.5rem', display: 'block'}}>
                   Where do you want to upload?
                 </label>
                 <select 
                   className="input-text"
                   value={activeTab === 'gallery' ? 'gallery' : activeTab === 'workshop' ? 'workshop' : 'materials'}
                   onChange={(e) => setActiveTab(e.target.value)}
                   style={{marginBottom: 0}}
                 >
                   {userRole !== 'student' && <option value="materials">Materials</option>}
                   <option value="gallery">Gallery</option>
                   <option value="workshop">Workshop</option>
                 </select>
              </div>

              <input 
                className="input-text" 
                placeholder="Description" 
                value={uploadDesc} 
                onChange={e => setUploadDesc(e.target.value)} 
              />
              
              <button 
                className="btn-primary" 
                style={{width:'100%', justifyContent:'center'}} 
                onClick={handleUpload} 
                disabled={isUploading || uploadFiles.length === 0}
              >
                {isUploading ? 'Uploading...' : 'Publish'}
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }

  if (activeTab === 'admin') {
    return (
      <div className="app-container">
        <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} onLogout={handleLogout} role={userRole} />
        
        <header className="mobile-header">
          <img src="/ITAD-LOGO2.jpg" alt="ITAD Logo" className="logo-mobile" />
          <button onClick={handleLogout} style={{background:'none', border:'none', cursor: 'pointer'}}>
            <LogOut size={20} />
          </button>
        </header>

        <main className="main-content">
          <AdminPanel />
        </main>

        <nav className="bottom-nav">
          <button 
            className={`nav-item ${activeTab === 'materials' ? 'active' : ''}`} 
            onClick={() => setActiveTab('materials')}
          >
            <FolderOpen size={20} />
            <span>Materials</span>
          </button>
          
          <button 
            className={`nav-item ${activeTab === 'gallery' ? 'active' : ''}`} 
            onClick={() => setActiveTab('gallery')}
          >
            <ImageIcon size={20} />
            <span>Gallery</span>
          </button>
          
          <button 
            className={`nav-item ${activeTab === 'workshop' ? 'active' : ''}`} 
            onClick={() => setActiveTab('workshop')}
          >
            <Briefcase size={20} />
            <span>Workshop</span>
          </button>
          <button 
  className={`nav-item ${activeTab === 'reviews' ? 'active' : ''}`} 
  onClick={() => setActiveTab('reviews')}
>
  <MessageSquare size={20} />
  <span>Reviews</span>
</button>
          <button 
            className={`nav-item ${activeTab === 'profile' ? 'active' : ''}`} 
            onClick={() => setActiveTab('profile')}
          >
            <User size={20} />
            <span>Profile</span>
          </button>

          {(userRole === 'admin' || userRole === 'docente') && (
            <button 
              className={`nav-item ${activeTab === 'admin' ? 'active' : ''}`} 
              onClick={() => setActiveTab('admin')}
            >
              <Users size={20} />
              <span>Users</span>
            </button>
          )}
        </nav>
      </div>
    );
  }

  // PAGINA WORKSHOP - Dedicata con filtro studenti
  if (activeTab === 'workshop') {
    return (
      <div className="app-container">
        <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} onLogout={handleLogout} role={userRole} />
        
        <header className="mobile-header">
          <img src="/ITAD-LOGO2.jpg" alt="ITAD Logo" className="logo-mobile" />
          <button onClick={handleLogout} style={{background:'none', border:'none', cursor: 'pointer'}}>
            <LogOut size={20} />
          </button>
        </header>

        <main className="main-content">
          <div className="header-section">
            <div>
              <h2>Student Assignment</h2>
              <p style={{color:'#666'}}>Student final projects and presentations</p>
            </div>
            <button className="btn-primary" onClick={() => setIsUploadOpen(true)} style={{ justifyContent: 'center' }}>
              <Plus size={20} /> Upload
            </button>
          </div>

          <WorkshopPage 
            user={user}
            userRole={userRole}
            items={items}
            onDelete={handleDeleteFile}
            canDelete={canDeleteFile}
          />
        </main>
      
        <nav className="bottom-nav">
          <button 
            className={`nav-item ${activeTab === 'materials' ? 'active' : ''}`} 
            onClick={() => setActiveTab('materials')}
          >
            <FolderOpen size={20} />
            <span>Materials</span>
          </button>
          
          <button 
            className={`nav-item ${activeTab === 'gallery' ? 'active' : ''}`} 
            onClick={() => setActiveTab('gallery')}
          >
            <ImageIcon size={20} />
            <span>Gallery</span>
          </button>
          
          <button 
            className={`nav-item ${activeTab === 'workshop' ? 'active' : ''}`} 
            onClick={() => setActiveTab('workshop')}
          >
            <Briefcase size={20} />
            <span>Workshop</span>
          </button>
          <button 
  className={`nav-item ${activeTab === 'reviews' ? 'active' : ''}`} 
  onClick={() => setActiveTab('reviews')}
>
  <MessageSquare size={20} />
  <span>Reviews</span>
</button>
          <button 
            className={`nav-item ${activeTab === 'profile' ? 'active' : ''}`} 
            onClick={() => setActiveTab('profile')}
          >
            <User size={20} />
            <span>Profile</span>
          </button>

          {(userRole === 'admin' || userRole === 'docente') && (
            <button 
              className={`nav-item ${activeTab === 'admin' ? 'active' : ''}`} 
              onClick={() => setActiveTab('admin')}
            >
              <Users size={20} />
              <span>Users</span>
            </button>
          )}
        </nav>

        {/* MODAL UPLOAD */}
        {isUploadOpen && (
          <div className="modal-overlay">
            <div className="modal-content">
              <div style={{display:'flex', justifyContent:'space-between', marginBottom:'1rem'}}>
                <h3>Upload to Workshop</h3>
                <button onClick={() => setIsUploadOpen(false)} style={{border:'none', background:'none'}}><X/></button>
              </div>
              
              <div className="upload-area">
                <input 
                  type="file" 
                  multiple 
                  accept={activeTab === 'gallery' ? "image/*,video/*" : "*/*"} 
                  onChange={e => setUploadFiles(Array.from(e.target.files))} 
                />
                
                {uploadFiles.length > 0 ? (
                  <div style={{textAlign: 'left', maxHeight: '100px', overflowY: 'auto'}}>
                    <p style={{fontWeight: 'bold', marginBottom: '5px'}}>{uploadFiles.length} files selected:</p>
                    {uploadFiles.map((f, i) => (
                      <p key={i} style={{fontSize: '0.8rem', margin: 0}}>• {f.name}</p>
                    ))}
                  </div>
                ) : (
                  <p>Select files</p>
                )}
              </div>

              <input 
                className="input-text" 
                placeholder="Description" 
                value={uploadDesc} 
                onChange={e => setUploadDesc(e.target.value)} 
              />
              
              <button 
                className="btn-primary" 
                style={{width:'100%', justifyContent:'center'}} 
                onClick={handleUpload} 
                disabled={isUploading || uploadFiles.length === 0}
              >
                {isUploading ? (
                  <>
                    <Loader2 className="animate-spin" /> 
                    Uploading... {uploadProgress}%
                  </>
                ) : 'Publish'}
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
  // --- AGGIUNGI QUESTO BLOCCO ---
  if (activeTab === 'reviews') {
    return (
      <div className="app-container">
        <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} onLogout={handleLogout} role={userRole} />
        
        <header className="mobile-header">
          <img src="/ITAD-LOGO2.jpg" alt="ITAD Logo" className="logo-mobile" />
          <button onClick={handleLogout} style={{background:'none', border:'none'}}><LogOut/></button>
        </header>

        <main className="main-content">
          {/* Qui renderizziamo il componente delle recensioni */}
          <ReviewsPage user={user} userRole={userRole} />
        </main>

        <nav className="bottom-nav">
          <button 
            className={`nav-item ${activeTab === 'materials' ? 'active' : ''}`} 
            onClick={() => setActiveTab('materials')}
          >
            <FolderOpen size={20} />
            <span>Materials</span>
          </button>
          
          <button 
            className={`nav-item ${activeTab === 'gallery' ? 'active' : ''}`} 
            onClick={() => setActiveTab('gallery')}
          >
            <ImageIcon size={20} />
            <span>Gallery</span>
          </button>
          
          <button 
            className={`nav-item ${activeTab === 'workshop' ? 'active' : ''}`} 
            onClick={() => setActiveTab('workshop')}
          >
            <Briefcase size={20} />
            <span>Workshop</span>
          </button>

          <button className={`nav-item ${activeTab === 'reviews' ? 'active' : ''}`} onClick={() => setActiveTab('reviews')}>
            <MessageSquare size={20} /> <span>Reviews</span>
          </button>

          <button 
            className={`nav-item ${activeTab === 'profile' ? 'active' : ''}`} 
            onClick={() => setActiveTab('profile')}
          >
            <User size={20} />
            <span>Profile</span>
          </button>

          {(userRole === 'admin' || userRole === 'docente') && (
            <button 
              className={`nav-item ${activeTab === 'admin' ? 'active' : ''}`} 
              onClick={() => setActiveTab('admin')}
            >
              <Users size={20} />
              <span>Users</span>
            </button>
          )}
        </nav>
      </div>
    );
  }
  // --- FINE BLOCCO AGGIUNTO ---
  return (
    <div className="app-container">
      <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} onLogout={handleLogout} role={userRole} />
      
      <header className="mobile-header">
       <img src="/ITAD-LOGO2.jpg" alt="ITAD Logo" className="logo-mobile" />
        <button onClick={handleLogout} style={{background:'none', border:'none'}}><LogOut/></button>
      </header>

      <main className="main-content">
       <div className="header-section">
          <div>
            <h2>{getPageTitle()}</h2>
            <p style={{color:'#666'}}>{getPageDescription()}</p>
          </div>
          
          <div style={{display: 'flex', gap: '10px'}}>
             {/* Pulsante Crea Cartella - Solo in Materials/Workshop */}
             {((activeTab === 'workshop') || (activeTab === 'materials' && userRole !== 'student')) && (
               <button className="btn-primary" onClick={handleCreateFolder} style={{background: '#fff', color: '#000', border: '1px solid #ddd'}}>
                 <Folder size={20} /> New Folder
               </button>
             )}

             {/* Pulsante Upload standard */}
             {(activeTab === 'gallery' || userRole !== 'student') && (
               <button className="btn-primary" onClick={() => setIsUploadOpen(true)} style={{ justifyContent: 'center' }}>
                 <Plus size={20} /> Upload
               </button>
             )}
          </div>
        </div>

        {/* --- NUOVA BARRA DI NAVIGAZIONE E AZIONI --- */}
        {/* --- NUOVA BARRA DI NAVIGAZIONE E AZIONI --- */}
        {(activeTab === 'materials' || activeTab === 'workshop') && (
          <div style={{ marginBottom: '1.5rem' }}>
            
            {/* NUOVO: Pulsante "Torna Indietro" e Breadcrumbs sulla stessa riga o sopra */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '1rem' }}>
              
              {/* Pulsante Indietro (Visibile solo se non siamo nella Root) */}
              {currentFolderId !== null && (
                <button 
                  onClick={() => handleNavigateUp(folderPath.length - 2)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '5px',
                    background: 'none',
                    border: 'none',
                    color: '#666',
                    fontSize: '0.9rem',
                    fontWeight: 600,
                    cursor: 'pointer',
                    padding: 0,
                    marginBottom: '5px',
                    width: 'fit-content'
                  }}
                >
                  <div style={{
                    background: '#eee', 
                    borderRadius: '50%', 
                    width: '24px', 
                    height: '24px', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center'
                  }}>
                    <ChevronLeft size={16} color="#333"/>
                  </div>
                  Back
                </button>
              )}

              {/* 1. Breadcrumbs (Navigazione classica) */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.85rem', flexWrap: 'wrap', color: '#888' }}>
                <span style={{color: '#aaa'}}>Path:</span>
                {folderPath.map((folder, index) => (
                  <React.Fragment key={index}>
                    <span 
                      onClick={() => handleNavigateUp(index)}
                      style={{ 
                        cursor: 'pointer', 
                        fontWeight: index === folderPath.length - 1 ? 'bold' : 'normal',
                        color: index === folderPath.length - 1 ? '#000' : '#666',
                        textDecoration: index !== folderPath.length - 1 ? 'underline' : 'none'
                      }}
                    >
                      {folder.name}
                    </span>
                    {index < folderPath.length - 1 && <span style={{color: '#ccc'}}>/</span>}
                  </React.Fragment>
                ))}
              </div>
            </div>

            {/* 2. Barra Azioni Multi-Selezione (Resta invariata sotto) */}
            {selectedItems.length > 0 && (
              /* ... (il resto del codice della barra azioni che hai già) ... */
              <div style={{ 
                background: '#e3f2fd', 
                padding: '10px 16px', 
                borderRadius: '8px', 
                display: 'flex', 
                alignItems: 'center', 
                gap: '12px',
                flexWrap: 'wrap'
              }}>
                {/* ... codice esistente dei pulsanti azione ... */}
                <span style={{ fontWeight: 600, fontSize: '0.9rem', color: '#1565c0', marginRight: 'auto' }}>
                  {selectedItems.length} selezionati
                </span>

                <button 
                  onClick={() => setIsMoveModalOpen(true)}
                  style={{ background: 'white', border: '1px solid #90caf9', color: '#1565c0', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}
                >
                  <ArrowUp size={16} /> Sposta in cartella
                </button>

                <button 
                  onClick={handleMoveToNewFolder}
                  style={{ background: 'white', border: '1px solid #90caf9', color: '#1565c0', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}
                >
                  <Plus size={16} /> Sposta e crea cartella
                </button>

                <button 
                  onClick={handleBatchDelete}
                  style={{ background: '#ffebee', border: '1px solid #ffcdd2', color: '#d32f2f', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}
                >
                  <Trash2 size={16} /> Elimina
                </button>
                
                <button onClick={() => setSelectedItems([])} style={{border:'none', background:'none', cursor:'pointer'}}><X size={18} color="#666"/></button>
              </div>
            )}
          </div>
        )}

        <div className={`grid ${activeTab === 'gallery' ? 'gallery-grid' : ''}`}>
          {/* FILTRO ELEMENTI: Solo quelli che appartengono alla cartella corrente o non hanno parentId (root) */}
          {items
            .filter(item => {
              if (activeTab === 'gallery') return true; // Gallery non ha cartelle in questa versione
              if (activeTab === 'profile' || activeTab === 'admin') return true;
              
              // Logica Filtro Cartelle
              const itemParent = item.parentId || null; // tratta undefined come null
              return itemParent === currentFolderId;
            })
            // Ordina: Cartelle prima, poi file
            .sort((a, b) => {
               if (a.type === 'folder' && b.type !== 'folder') return -1;
               if (a.type !== 'folder' && b.type === 'folder') return 1;
               return 0;
            })
            .map((item, index) => {
              const isSelected = selectedItems.includes(item.id);
              const isFolder = item.type === 'folder';

              return (
              <div 
                key={item.id} 
                className="card" 
                style={{ 
                  position: 'relative',
                  border: isSelected ? '2px solid #2196f3' : '1px solid #eee',
                  background: isSelected ? '#f5f9ff' : 'white'
                }}
              >
                {/* --- CHECKBOX SELEZIONE (Solo Materials/Workshop) --- */}
                {((activeTab === 'workshop') || (activeTab === 'materials' && userRole !== 'student')) && (
                  <div 
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleSelection(item.id);
                    }}
                    style={{
                      position: 'absolute',
                      top: '10px',
                      left: '10px',
                      zIndex: 30,
                      cursor: 'pointer'
                    }}
                  >
                    {isSelected ? 
                      <CheckSquare size={20} color="#2196f3" fill="white" /> : 
                      <Square size={20} color="#ccc" fill="rgba(255,255,255,0.8)" />
                    }
                  </div>
                )}

                {/* --- GESTIONE CLICK PRINCIPALE --- */}
                {/* Se è una cartella -> Entra. Se è un file -> Apri link (se non in gallery mode) */}
                {isFolder ? (
                  <div 
                    onClick={() => handleEnterFolder(item)}
                    style={{ cursor: 'pointer', position: 'absolute', inset: 0, zIndex: 10 }}
                  />
                ) : activeTab === 'gallery' ? (
  <div 
    onClick={() => {
      setLightboxIndex(index);
      setLightboxOpen(true);
    }}
    style={{ cursor: 'pointer', position: 'absolute', inset: 0, zIndex: 10 }}
  />
) : (
                  <a 
                    href={item.url} 
                    target="_blank" 
                    rel="noreferrer" 
                    className="card-link"
                    style={{ zIndex: 10 }}
                  >
                    <span style={{ display: 'none' }}>Open</span>
                  </a>
                )}
                
                {/* PULSANTE ELIMINA SINGOLO (Manteniamo per retrocompatibilità o admin rapido) */}
                {canDeleteFile(item) && !isFolder && activeTab !== 'gallery' && (
  <button 
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      handleDeleteFile(item);
    }}
                    style={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      zIndex: 20,
                      background: 'rgba(255, 68, 68, 0.9)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '50%',
                      width: '32px',
                      height: '32px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                    }}
                  >
                    <Trash2 size={16} />
                  </button>
                )}
                
                {/* --- CONTENUTO CARD --- */}
                {activeTab === 'materials' || activeTab === 'workshop' ? (
                   <div className="material-card">
                     <div className="icon-box" style={{ background: isFolder ? '#fff3e0' : '#eef2ff' }}>
                       {isFolder ? <Folder color="#f57c00" /> : <FileText />}
                     </div>
                     <div style={{flex: 1, minWidth: 0}}>
                       <h4 style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{item.description}</h4>
                       <p style={{fontSize: '0.8rem'}}>{isFolder ? 'Folder' : item.fileName}</p>
                     </div>
                   </div>
                ) : (
                  <div className="photo-card" style={{ 
  display: 'flex', 
  flexDirection: 'column', 
  background: 'white', 
  borderRadius: '8px', 
  overflow: 'hidden',  
  boxShadow: '0 2px 5px rgba(0,0,0,0.05)',
  position: 'relative' // Importante per i posizionamenti interni
}}>
  {/* 1. PARTE SUPERIORE: QUADRATA (aspectRatio: '1/1') */}
  <div style={{ 
    width: '100%', 
    aspectRatio: '1/1', 
    position: 'relative', 
    background: '#eee' 
  }}>
    {/* Contenuto Immagine/Video */}
    {item.mimeType && item.mimeType.startsWith('video/') ? (
      <div style={{width: '100%', height: '100%', position: 'absolute', inset: 0, background: '#000'}}>
        <video 
          src={item.url + "#t=0.1"} 
          style={{width: '100%', height: '100%', objectFit: 'cover', opacity: 0.8}}
          preload="none"
          muted
        />
        <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', color: 'white'}}>
          <PlayCircle size={40} fill="rgba(0,0,0,0.5)" />
        </div>
      </div>
    ) : (
      <div style={{width: '100%', height: '100%', position: 'absolute', inset: 0}}>
          <ThumbnailImage item={item} />
      </div>
    )}
    
    {/* --- GESTORE CLICK LIGHTBOX (SOLO SULLA FOTO) --- */}
    {/* Questo livello invisibile sta SOPRA l'immagine ma SOTTO la descrizione */}
    <div 
      onClick={() => {
        setLightboxIndex(index);
        setLightboxOpen(true);
      }}
      style={{ cursor: 'pointer', position: 'absolute', inset: 0, zIndex: 10 }}
      title="View fullscreen"
    />
  </div>

  {/* 2. PARTE INFERIORE: DESCRIZIONE CON MODIFICA */}
  {/* zIndex: 20 assicura che questo blocco stia SOPRA il livello cliccabile della foto */}
  <div style={{ 
    padding: '10px 12px', 
    borderTop: '1px solid #f0f0f0',
    background: '#fff',
    minHeight: '42px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
    position: 'relative', 
    zIndex: 20 
  }}>
    
    {editingId === item.id ? (
      // === MODALITÀ MODIFICA ===
      <div style={{ display: 'flex', width: '100%', alignItems: 'center', gap: '5px' }}>
        <input 
          type="text"
          value={editDescription}
          onChange={(e) => setEditDescription(e.target.value)}
          onClick={(e) => e.stopPropagation()} 
          onKeyDown={(e) => { if(e.key === 'Enter') handleSaveDescription(item.id); }}
          autoFocus
          style={{
            flex: 1,
            border: '1px solid #2196f3',
            borderRadius: '4px',
            padding: '4px 8px',
            fontSize: '0.85rem',
            outline: 'none'
          }}
        />
        <button 
  onClick={(e) => {
    e.stopPropagation();
    handleSaveDescription(item.id);
  }}
  style={{ 
    border: 'none', 
    background: '#e8f5e9', 
    borderRadius:'4px', 
    cursor: 'pointer', 
    color: 'green', 
    padding: '4px',
    display: 'flex',       // AGGIUNTO
    alignItems: 'center',  // AGGIUNTO
    flexShrink: 0          // <--- FONDAMENTALE: Impedisce al bottone di sparire
  }}
  title="Save"
>
  <Check size={18} />
</button>

{/* Tasto ANNULLA (Rosso) */}
<button 
  onClick={(e) => {
    e.stopPropagation();
    setEditingId(null);
  }}
  style={{ 
    border: 'none', 
    background: '#ffebee', 
    borderRadius:'4px', 
    cursor: 'pointer', 
    color: 'red', 
    padding: '4px',
    display: 'flex',       // AGGIUNTO
    alignItems: 'center',  // AGGIUNTO
    flexShrink: 0          // <--- FONDAMENTALE
  }}
  title="Cancel"
>
  <X size={18} />
</button>
      </div>
    ) : (
      // === MODALITÀ VISUALIZZAZIONE ===
      <>
        <div style={{ flex: 1, minWidth: 0, cursor: 'default' }} onClick={(e) => e.stopPropagation()}>
          <p style={{ 
            margin: 0, 
            fontSize: '0.85rem', 
            color: '#444', 
            fontWeight: 500,
            whiteSpace: 'nowrap', 
            overflow: 'hidden', 
            textOverflow: 'ellipsis'
          }}>
            {item.description || <span style={{color:'#ccc', fontStyle:'italic'}}>-</span>}
          </p>
        </div>

        {/* Pulsanti Azione */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
          
          {/* MATITA: Solo admin o proprietario */}
          {(userRole === 'admin' || item.uploadedBy === user.email) && (
            <button 
              onClick={(e) => {
                e.stopPropagation(); // BLOCCA il click verso la lightbox
                e.preventDefault();
                setEditingId(item.id);
                setEditDescription(item.description || ""); 
              }}
              style={{ 
                border: 'none', 
                background: 'transparent', 
                cursor: 'pointer', 
                color: '#999',
                padding: '6px',
                borderRadius: '50%',
                display: 'flex'
              }}
              title="Edit description"
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
            >
              <Edit size={16} />
            </button>
          )}

           {/* CESTINO (opzionale qui, se lo vuoi anche nella card) */}
           {canDeleteFile(item) && (
             <button 
               onClick={(e) => {
                 e.stopPropagation();
                 handleDeleteFile(item);
               }}
               style={{ border: 'none', background: 'transparent', cursor: 'pointer', color: '#ff4444', padding: '6px', borderRadius:'50%', display:'flex' }}
               title="Delete"
               onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#ffebee'}
               onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
             >
               <Trash2 size={16} />
             </button>
           )}
        </div>
      </>
    )}
  </div>
</div>
                )}
              </div>
            );
          })}
        </div>
        {activeTab === 'gallery' && items.length >= itemsLimit && (
          <div style={{display:'flex', justifyContent:'center', margin:'2rem 0'}}>
            <button 
              className="btn-primary" 
              onClick={() => setItemsLimit(prev => prev + 15)}
              style={{background:'white', color:'#333', border:'1px solid #ccc'}}
            >
              Load More
            </button>
          </div>
        )}
      </main>

      <nav className="bottom-nav">
        <button 
          className={`nav-item ${activeTab === 'materials' ? 'active' : ''}`} 
          onClick={() => setActiveTab('materials')}
        >
          <FolderOpen size={20} />
          <span>Materials</span>
        </button>
        
        <button 
          className={`nav-item ${activeTab === 'gallery' ? 'active' : ''}`} 
          onClick={() => setActiveTab('gallery')}
        >
          <ImageIcon size={20} />
          <span>Gallery</span>
        </button>
        
        {/* TAB WORKSHOP invece del FAB */}
        <button 
          className={`nav-item ${activeTab === 'workshop' ? 'active' : ''}`} 
          onClick={() => setActiveTab('workshop')}
        >
          <Briefcase size={20} />
          <span>Workshop</span>
        </button>
        <button 
  className={`nav-item ${activeTab === 'reviews' ? 'active' : ''}`} 
  onClick={() => setActiveTab('reviews')}
>
  <MessageSquare size={20} />
  <span>Reviews</span>
</button>
        <button 
          className={`nav-item ${activeTab === 'profile' ? 'active' : ''}`} 
          onClick={() => setActiveTab('profile')}
        >
          <User size={20} />
          <span>Profile</span>
        </button>

        {(userRole === 'admin' || userRole === 'docente') && (
          <button 
            className={`nav-item ${activeTab === 'admin' ? 'active' : ''}`} 
            onClick={() => setActiveTab('admin')}
          >
            <Users size={20} />
            <span>Users</span>
          </button>
        )}
      </nav>

      {isUploadOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div style={{display:'flex', justifyContent:'space-between', marginBottom:'1rem'}}>
              <h3>Upload to {activeTab === 'materials' ? 'Materials' : activeTab === 'gallery' ? 'Gallery' : 'Workshop'}</h3>
              <button onClick={() => setIsUploadOpen(false)} style={{border:'none', background:'none'}}><X/></button>
            </div>
            
            <div className="upload-area">
              <input 
                type="file" 
                multiple 
                accept={activeTab === 'gallery' ? "image/*,video/*" : "*/*"} 
                onChange={e => setUploadFiles(Array.from(e.target.files))} 
              />
              
              {/* Mostra riepilogo file selezionati */}
              {uploadFiles.length > 0 ? (
                <div style={{textAlign: 'left', maxHeight: '100px', overflowY: 'auto'}}>
                  <p style={{fontWeight: 'bold', marginBottom: '5px'}}>{uploadFiles.length} files selected:</p>
                  {uploadFiles.map((f, i) => (
                    <p key={i} style={{fontSize: '0.8rem', margin: 0}}>• {f.name}</p>
                  ))}
                </div>
              ) : (
                <p>Select files (Photos or Videos)</p>
              )}
            </div>

            <input 
              className="input-text" 
              placeholder="Description (optional)" 
              value={uploadDesc} 
              onChange={e => setUploadDesc(e.target.value)} 
            />
            
            <button 
              className="btn-primary" 
              style={{width:'100%', justifyContent:'center'}} 
              onClick={handleUpload} 
              disabled={isUploading || uploadFiles.length === 0}
            >
              {isUploading ? 'Uploading...' : 'Publish'}
            </button>
          </div>
        </div>
      )}
      
      {/* LIGHTBOX per Gallery */}
      {lightboxOpen && activeTab === 'gallery' && items.length > 0 && (
        <ImageLightbox 
    images={items}
    initialIndex={lightboxIndex}
    onClose={() => setLightboxOpen(false)}
    canDelete={canDeleteFile}
    onDelete={handleDeleteFile}
  />
)}
      {/* MODALE SPOSTA IN CARTELLA ESISTENTE */}
      {isMoveModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div style={{display:'flex', justifyContent:'space-between', marginBottom:'1rem'}}>
              <h3>Sposta in...</h3>
              <button onClick={() => setIsMoveModalOpen(false)} style={{border:'none', background:'none'}}><X/></button>
            </div>
            
            <div style={{ maxHeight: '300px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '8px' }}>
              
              {/* Opzione per tornare alla Root */}
              {currentFolderId !== null && (
                <button 
                  onClick={() => handleMoveToExisting(null)}
                  style={{ textAlign: 'left', padding: '12px', background: '#f5f5f5', border: 'none', borderRadius: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '10px' }}
                >
                  <FolderOpen size={18} /> Home (Root)
                </button>
              )}

              {/* Lista cartelle disponibili (escludendo quella corrente e quelle selezionate) */}
              {items
                .filter(i => 
                  i.type === 'folder' && 
                  i.id !== currentFolderId && 
                  !selectedItems.includes(i.id)
                )
                .map(folder => (
                  <button 
                    key={folder.id}
                    onClick={() => handleMoveToExisting(folder.id)}
                    style={{ textAlign: 'left', padding: '12px', background: 'white', border: '1px solid #eee', borderRadius: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '10px' }}
                  >
                    <Folder size={18} color="#f57c00" /> {folder.description}
                  </button>
                ))
              }
              
              {items.filter(i => i.type === 'folder' && i.id !== currentFolderId).length === 0 && currentFolderId === null && (
                <p style={{color: '#999', textAlign: 'center', padding: '1rem'}}>Nessuna altra cartella disponibile.</p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}